
const backUrl = 'https://live.wizito.com/api'//'http://localhost:3000/api'
const location = () => (typeof window !== `undefined`) ? window.location : { search: '', pathname: '' }
const token = 'f3737b742350d587224d8b932569e0e532381b44' // urlParams.get('token')
const event = '25079'

const headers = { Authorization: `Token token="${token}"`, 'Content-Type': 'application/json' }

export function getConfig() {
  return fetch(`${backUrl}/events/${event}?event_token=${token}`, { method: 'GET', headers }).then(res => res.json())
}

export function createSession(answers, photo, svg) {
  return fetch(`${backUrl}/photos/create_from_svg?event_token=${token}`, {
    headers,
    method: 'POST',
    body: JSON.stringify({ answers, photo, svg })
  }).then(res => !res.ok && Promise.reject())
}

export function like(photo) {
  return fetch(`${backUrl}/events/${event}/photos/${photo.id}/like`, { method: 'PUT' })
}

export function unlike(photo) {
  return fetch(`${backUrl}/events/${event}/photos/${photo.id}/unlike`, { method: 'PUT' })
}
